<template>
  <div class="d-flex flex-column">
    <div class="d-flex ga-1 align-center">
      <sf-secondary-text>{{ $t('clientNumber') }}</sf-secondary-text>
      <sf-text>{{ order.customerNumber }}</sf-text>
    </div>
    <div class="d-flex ga-1 align-center">
      <sf-secondary-text>{{ $t('order.orderNumber') }}</sf-secondary-text>
      <sf-text>{{ order.orderNumber }}</sf-text>
    </div>
    <div v-if="order.customerOrderId" class="d-flex ga-1 align-center">
      <sf-secondary-text>{{ $t('customerOrderId') }}</sf-secondary-text>
      <sf-text>{{ order.customerOrderId }}</sf-text>
    </div>
    <div v-if="order.sentDate" class="d-flex ga-1 align-center">
      <sf-secondary-text>{{ $t('order.orderDate') }}</sf-secondary-text>
      <sf-text>{{ formatDate(order.sentDate) }}</sf-text>
    </div>
  </div>
</template>

<script setup lang="ts">
import SfSecondaryText from '@/components/text/SfSecondaryText.vue'
import SfText from '@/components/text/SfText.vue'
import { DetailedOrder } from '@/types/index'
import { formatDate } from '@/utils/timeFormatHelpers'
import { PropType } from 'vue'

defineProps({
  order: {
    type: Object as PropType<DetailedOrder>,
    required: true
  }
})
</script>
